import { render } from "./index.vue?vue&type=template&id=60985a74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=60985a74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60985a74"],['__file',"src/views/Lounge/component/fromBenefits/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60985a74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60985a74', __exports__)) {
    api.reload('60985a74', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=60985a74&scoped=true", () => {
    api.rerender('60985a74', render)
  })

}


export default __exports__